import React, { useState, useCallback } from 'react';
import { Box, Typography, Divider } from '@mui/material';
import CustomerPipeline from './CustomerPipeline';
import ExecutionLog from './ExecutionLog';

interface LogEntry {
  timestamp: string;
  level: 'info' | 'success' | 'error' | 'warning';
  message: string;
}

function PipelineManager() {
  const [logEntries, setLogEntries] = useState<LogEntry[]>([]);

  const addLogEntry = useCallback(
    (level: 'info' | 'success' | 'error' | 'warning', message: string) => {
      const entry: LogEntry = {
        timestamp: new Date().toLocaleTimeString(),
        level,
        message,
      };
      setLogEntries(prev => [...prev, entry]);
    },
    []
  );

  const clearLog = useCallback(() => setLogEntries([]), []);

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h4" sx={{ mb: 1 }}>
        Pipeline Manager
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Load configuration data for the currently-selected tenant + environment.
      </Typography>

      <CustomerPipeline addLogEntry={addLogEntry} />

      <Divider sx={{ my: 4 }} />

      <ExecutionLog entries={logEntries} onClear={clearLog} />
    </Box>
  );
}

export default PipelineManager;
